import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import jsCookie from 'js-cookie';

const ProtectedRoute = ({ component: Component, ...rest }) => {

  const isAuthenticated = jsCookie.get('loggedIn') === 'true';

  return (
    <Route 
      {...rest}
      render={(props) => 
        isAuthenticated ? (
          <Component {...props} />
        ) : (
          <Redirect to="/signin" />
        )  
      }
    />
  ); 
};

export default ProtectedRoute;